import lodashGet from 'lodash/get';

export type ExtractExpr<T = any, K = any> =
  | keyof T
  | string
  | ((item: T, index: number) => K);

export class ItemExprUtils {
  static extractValue<T = any>(
    item: T,
    index: number,
    valueExpr?: ExtractExpr<T>
  ) {
    if (valueExpr) {
      let aux;
      if (typeof valueExpr === 'function') {
        aux = valueExpr(item, index);
      } else {
        aux = !item ? null : lodashGet(item, valueExpr);
      }

      return aux;
    }

    return item;
  }
}
